/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import columnsAdapter from '../helpers/columnsAdapter';

interface ComponentProps extends SingleObjectDataStructure {
  columns: SingleColumn[];
  dataSource: SingleObjectDataStructure[];
  searchableColumns: string[];
  search: string;
  id?: string;
}
/**
 * Handler zwracający komponent tabeli z przefiltrowanymi na podstawie wartości "search" danymi
 * oraz konfiguracją sortowania danych. Stosowany dla tabel, gdzie sortowanie i wyszukiwanie
 * kontekstowe odbywa się "po froncie"
 */

// eslint-disable-next-line react/display-name
export const withTableDataHandler =
  <P extends ComponentProps>(Comp: any) =>
  (props: P): any => {
    const [filteredData, setFilteredData] = useState(props.dataSource);
    useEffect(() => {
      if (props.search && props.search.length) {
        const data = props.dataSource.filter(item =>
          Object.keys(item)
            .filter(key => props.searchableColumns.includes(key))
            .some(key => {
              const value =
                item[key] && (typeof item[key] === 'string' || typeof item[key] === 'number')
                  ? item[key].toString().toLowerCase()
                  : '';
              return value.includes(props.search.toLowerCase());
            }),
        );
        setFilteredData(data);
      } else {
        setFilteredData(props.dataSource);
      }
    }, [props.dataSource, props.search]);
    return (
      <Comp
        {...props}
        columns={columnsAdapter.addSorter(props.columns)}
        dataSource={filteredData}
        pagination={false}
        showSorterTooltip={false}
      />
    );
  };

export default withTableDataHandler;
